import { formatDate } from "./DurationFormatter"
export default function loadDuration(container: HTMLElement, dur: string) {
  var durationElement = document.createElement("div")
  durationElement.textContent = formatDate(dur)
  durationElement.classList.add("parmonic-video-duration")
  durationElement.classList.add("show")
  container.appendChild(durationElement)
  return durationElement
}
